module.exports = __webpack_public_path__ + "2d190e8943d111b0c2967c2ebad0d2b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/index/bg.jpg
// module id = 1133
// module chunks = 75